import { orderBy, type SortDescriptor } from '@progress/kendo-data-query';

export type SortDirection = 'asc' | 'desc';

const toArray = <T>(items: readonly T[]): T[] => [...items];

export const orderByField = <T>(
  items: readonly T[],
  field?: string | null,
  dir: SortDirection = 'asc',
): T[] => {
  if (!field) {
    return toArray(items);
  }

  return orderBy(toArray(items), [{ field, dir }]);
};

export const orderByDescriptors = <T>(
  items: readonly T[],
  descriptors?: readonly SortDescriptor[] | null,
): T[] => {
  if (!descriptors || descriptors.length === 0) {
    return toArray(items);
  }

  return orderBy(toArray(items), descriptors as SortDescriptor[]);
};
